import { Component, input } from '@angular/core';

import { LandingText } from '../landing.types';
import { LandingGlow } from './landing-glow.component';
import { RevealOnScrollDirective } from './reveal-on-scroll.directive';

@Component({
    selector: 'app-landing-how',
    standalone: true,
    imports: [LandingGlow, RevealOnScrollDirective],
    templateUrl: './landing-how.component.html',
    styleUrl: './landing-how.component.scss'
})
export class LandingHow {
    readonly text = input.required<LandingText>();
}
